import axios from "axios";
import { baseURL } from "../../constants/Api";

export const payment_ = async (bookedFor, eventId, hotelId, appUserId) => {
  let config = {
    method: "post",
    url: `${baseURL}/api/payment`,
    headers: {
      Accept: "application/json",
    },
    data: {
      amount: 69,
    },
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const verify_payment = async (
  razorpay_payment_id,
  razorpay_order_id,
  razorpay_signature,
  bookingId,
  hotelId,
  price,
  app_user_id

) => {
  //razorpay_payment_id
  let config = {
    method: "post",
    url: `${baseURL}/api/verify`,
    headers: {
      Accept: "application/json",
    },
    data: {
      hotel_id: hotelId,
      razorpay_order_id: razorpay_order_id,
      razorpay_payment_id: razorpay_payment_id,
      razorpay_signature: razorpay_signature,
      amount: price,
      redirect: "event",
      redirect_id: bookingId,
      booking_id :bookingId,
      app_user_id
    },
  };

  try {
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
